export const CARD_SIZES = {
  small: "400px",
  medium: "600px",
  large: "800px",
  extraLarge: "1000px",
  maxContent: "max-content" // Delegate width to children
}
